module.exports = __webpack_public_path__ + "images/45bb46512c3a7cb57fa6ef6784a56d03.jpg";